import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RiVipCrownFill } from "react-icons/ri";
import members from "../../../assets/images/membership_levels.png";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import data from "../../../json/membership.json";
import { useTranslation } from "react-i18next";

export default function Demande() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [user, setUser] = useState();
  const [packs, setPacks] = useState([]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserAndPacks = async () => {
      try {
        const auth = localStorage.getItem("user");
        if (auth) setUser(JSON.parse(auth));

        const response = await axios.get(`${baseUrl}/packs`);
        setPacks(response.data.packs);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUserAndPacks();
  }, [baseUrl]);



  const handlePackSelect = (pack) => {
    const userPack = user?.membership?.membership_packs;

    if (userPack?.id === pack.id) {
      setMessage(`You are already a ${pack.name} member`);
      setTimeout(() => setMessage(null), 3000);
      return;
    }

    if (parseInt(userPack?.price) > parseInt(pack.price)) {
      setError("You can't downgrade your pack.");
      setTimeout(() => setError(null), 3000);
    } else {
      navigate("/membership/welcometwo", {
        state: {
          pack: pack?.name,
          id: pack?.id,
          price: pack?.price,
        },
      });
    }
  };

  return (
    
          <div className="bg-black shadow-custom text-white h-full bg-opacity-[87%] flex flex-col items-center justify-start gap-4 md:gap-10 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
            <div className="text-center text-3xl md:text-4xl font-bold">
              <p>{t("membership_request.title")}</p>
            </div>

            <div className="flex justify-center w-full">
              <img
                src={members}
                className="w-full lg:max-w-[400px] max-w-[300px]"
                alt="membership_levels"
              />
            </div>

            <div className="w-full md:w-[50%] text-center px-4 md:px-0">
              <p className="text-sm md:text-base">
                {t("membership_request.unlock_features")}
              </p>
            </div>

            <div className="flex flex-col w-full md:w-[40%] gap-4 md:gap-5 mt-6 md:mt-10 px-4 md:px-0">
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
                </div>
              ) : (
                packs
                  .sort((a, b) => a.order - b.order)
                  ?.map((pack) => (
                    <button
                      key={pack.id}
                      onClick={() => handlePackSelect(pack)}
                      className="flex font-bold p-3 rounded-xl hover:opacity-70 w-full"
                      style={{
                        backgroundImage: `url(${pack.background})`,
                        backgroundColor: `${pack.color}`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="flex text-white w-full justify-between items-center">
                        <div className="flex gap-2 items-center">
                          <RiVipCrownFill size={20} color="white" />
                          <p className=" text-lg md:text-xl">
                            {pack.name}
                          </p>
                        </div>
                        <div className="relative flex">
                          <span className="absolute top-[-8px] right-0  text-[10px]">
                            TTC
                          </span>
                          <span className=" text-lg md:text-xl">
                            {pack.price} MAD
                          </span>
                        </div>
                      </div>
                    </button>
                  ))
              )}
              {error && (
                <p className="text-red-500 font-semibold text-center text-sm md:text-base">
                  {error}
                </p>
              )}
              {message && (
                <p className="text-green-500 font-semibold text-center text-sm md:text-base">
                  {message}
                </p>
              )}
            </div>
          </div>
      
  );

  // return (
  //   <div
  //     className="flex flex-col gap-12 min-h-screen"
  //     style={{
  //       backgroundImage: `url(${images.golf_field})`,
  //       backgroundPosition: "center",
  //       backgroundSize: "cover",
  //       backgroundRepeat: "no-repeat",
  //     }}
  //   >
  //     <Nav />
  //     <div className="flex justify-center mx-16 mb-20">
  //       <div className="flex w-full justify-between items-start">
  //         <Sidebar />
  //         <div className="bg-black shadow-custom text-white h-full bg-opacity-[87%] flex flex-col items-center justify-start gap-10 w-[75%] rounded-3xl py-12">
  //           <div className="text-center text-3xl font-semibold">
  //             <p>Demande d’adhésion</p>
  //           </div>

  //           <div className="flex justify-center flex-row gap-32">
  //             <img src={members} width={400} alt="membership_levels" />
  //           </div>

  //           <div className="w-[50%] text-center">
  //             <p>
  //               Débloquez des fonctionnalités exclusives et améliorez votre
  //               expérience avec notre Compte Premium en choisissant l'un de ces
  //               plans.
  //             </p>
  //           </div>

  //           <div className="flex flex-col w-[40%] gap-5 mt-10">
  //             {loading ? (
  //               <div className="text-center">Chargement...</div>
  //             ) : (
  //               packs?.map((pack) => (
  //                 <button
  //                   key={pack.id}
  //                   onClick={() => handlePackSelect(pack)}
  //                   className="flex font-bold p-3 rounded-xl hover:opacity-70"
  //                   style={{
  //                     backgroundImage: `url(${pack.background})`,
  //                     backgroundPosition: "center",
  //                     backgroundRepeat: "no-repeat",
  //                     backgroundSize: "cover",
  //                   }}
  //                 >
  //                   <div className="flex w-full justify-between items-center">
  //                     <div className="flex gap-2 items-center">
  //                       <RiVipCrownFill size={20} color="black" />
  //                       <p className="text-black text-xl">{pack.name}</p>
  //                     </div>
  //                     <div className="relative flex">
  //                       <span className="absolute top-[-8px] right-0 text-black text-[10px]">
  //                         TTC
  //                       </span>
  //                       <span className="text-black text-xl">
  //                         {pack.price} MAD
  //                       </span>
  //                     </div>
  //                   </div>
  //                 </button>
  //               ))
  //             )}
  //             {error && <p className="text-red-500 font-semibold text-center">{error}</p>}
  //             {message && <p className="text-green-500 font-semibold text-center">{message}</p>}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}
